import type { CanvasToolKey } from "../canvasToolbarComposition";

/** The tiles that open the tray; Cursor's is the pen kit under Draw. */
export type CanvasTrayKey = Extract<
  CanvasToolKey,
  "cursor" | "sticky" | "text" | "shapes" | "blocks" | "stickers" | "connectors"
>;

export const CANVAS_TRAY_KEYS: CanvasTrayKey[] = [
  "cursor",
  "sticky",
  "text",
  "shapes",
  "blocks",
  "stickers",
  "connectors",
];

/** Titles are the trigger tooltip verbatim, so opening a tray confirms
 * rather than renames; Cursor's tray is the Draw kit. */
export const CANVAS_TRAY_TITLES: Record<CanvasTrayKey, string> = {
  cursor: "Draw",
  sticky: "Sticky note",
  text: "Text · Label",
  shapes: "Shapes",
  blocks: "Blocks",
  stickers: "Stickers",
  connectors: "Connectors",
};

export function isCanvasTrayKey(
  key: string | null | undefined,
): key is CanvasTrayKey {
  return !!key && (CANVAS_TRAY_KEYS as string[]).includes(key);
}
